import React, { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../../../Loader/Loader";
import { DeleteUnverifiedPhotographerAPI } from "../../../../utils/APIs/photographersApis";

const DeletePhotographerModal = ({ isOpen, onClose, photographer, onDeleted }) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen || !photographer) return null;

  const handleDelete = async () => {
    try {
      setLoading(true);

      const res = await DeleteUnverifiedPhotographerAPI(photographer._id);

      if (res?.data?.success) {
        toast.success(res?.data?.message || "Photographer deleted successfully");
        onDeleted(); // refresh table
        onClose();
      } else {
        toast.error(res?.data?.message || "Delete failed");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message || "Failed to delete photographer"
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="photographer-modal-overlay">
      <div className="photographer-add-modal-content">
        <h3>Delete Photographer</h3>

        <p>
          Are you sure you want to delete <strong>{photographer.name}</strong>?
        </p>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>

          <button className="btn-add" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePhotographerModal;
